export enum CompanyType {
    Unknown = 0,
    Client = 1,
    Advisor = 2,
}
